export default __webpack_public_path__ + "tmp_src/components/LightBox/LightBox.css.liquid";